/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NoAuthUpdatePasswordDto } from '../../models/no-auth-update-password-dto';

export interface PatchUserControllerNoAuthUpdatePassword$Params {
      body: NoAuthUpdatePasswordDto
}

export function patchUserControllerNoAuthUpdatePassword(http: HttpClient, rootUrl: string, params: PatchUserControllerNoAuthUpdatePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, patchUserControllerNoAuthUpdatePassword.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

patchUserControllerNoAuthUpdatePassword.PATH = '/api/user/no-auth/password';
